import Utils from '../../src/lib/util.js';
import CryptoJS from "crypto-js";
import API from "@/lib/api.js";
// 十六位十六进制数作为密钥
const SECRET_KEY = CryptoJS.enc.Utf8.parse("1234123412341234");
// 十六位十六进制数作为密钥偏移量
const SECRET_IV = CryptoJS.enc.Utf8.parse("1234123412341234");

export default {
	altermsg(){
		alert(1);
	},
	getmainpage(_this){
		var that=this;
		var obj='';
		//debugger
		if(_this.$vnode!=undefined){
			if(_this.$vnode.tag.indexOf('-pagemain')>-1)
				obj=_this;
			else
				obj=that.getmainpage(_this.$parent);
		}
		return obj;
	},
	//中控中心根据操作来触发事件
	ActionControl(param,_this){
		//debugger
		var l_id=param.l_id;
		if(param.l_handetype==undefined)
			param.l_handetype='';
		var currentpage=this.getmainpage(_this);
		//判断点击的操作是打开页面 还是弹窗
		//如果是打开页面,返回标识  opentab--表示是打开选项卡
		if(param.l_tabevent!='0'&&param.l_tabevent!=undefined)
			//指定页面的操作方法
			l_id=param.l_tabevent;
		//debugger
		if(l_id!='')
			param=this.BtnClick(param);
			
		if(param.l_handetype=='otherurl')
			window.open(param.l_tablename,'_blank');
		else if(param.l_handetype=='opensmallwin'){
			this.opendialog(param,currentpage);
		}
		else{
			var isgo=this.BtnEvent(l_id,_this,currentpage,param);
			if(isgo)
				this.opentab(param,currentpage);
		}
	},
	opentab(e,_this){
			_this.urlparam={};
			if(e.l_url==undefined||e.l_url==''){
				return ;
			}
			let a = 0;
			for (let i = 0; i < _this.tablist.length; i++) {
				if (e.l_name == _this.tablist[i].l_name||e.l_id==_this.tablist[i].l_id) {
					_this.activeName = _this.tablist[i].l_name;
					_this.activeIndex = i;
					_this.activelid=_this.tablist[i].l_id;
					_this.l_tablename=_this.tablist[i].l_tablename;
					a++;
				}
			}
			if (a == 0) {
				if (e.urlparam != undefined) {
					if(e.l_tablename!=undefined)
						e.urlparam.l_tablename=e.l_tablename;
					_this.urlparam = e.urlparam;
				}else
					_this.urlparam={l_tablename:e.l_tablename};
				if(e.l_name==''||e.l_name==undefined){
					var isexists=false;
					var menulist=JSON.parse(localStorage.getItem('menulist'));
					menulist.forEach(meun=>{
						if(meun.l_id.toString()==e.l_id.toString()){
							e.l_name=meun.l_name;
							return false;
						}else{
							if(meun.sonlist!=undefined){
								meun.sonlist.forEach(son=>{
									if(son.l_id.toString()==e.l_id.toString()){
										e.l_name=son.l_name;
										return false;
									}
								});
							}
						}
					});
				}
				//debugger
				_this.tablist.push(e);
				_this.activeName = e.l_name;
			}
			this.setlocal(_this);
	},
	setlocal(_this) {
		localStorage.setItem('tablist', JSON.stringify(_this.tablist));
		localStorage.setItem('tabindex', _this.activeIndex);
		localStorage.setItem('tabname', _this.activeName);
		localStorage.setItem('l_tablename', _this.l_tablename);
		for(let i=0;i<_this.refresh.length;i++){
			//debugger
			if(_this.refresh[i]==_this.activelid){
				setTimeout(function(){
					Utils.$emit('refreshgrid');
				},30); 
				break;
			}
		}
	},
	opendialog(item,_this){
		//debugger
		_this.showdialog=true;
		_this.$nextTick(() => {
			_this.$refs.maindialog.init({item:item,urlparam:_this.urlparam});
		});
	},
	//获取指定模块的语言包
	GetLanguageByMode(mode,_this){
		return new Promise((resolve, reject) => {
			var lang=_this.$langtype;
			var isgo=true;
			if(_this.$lang.label!=undefined)
			{
				if(_this.$lang.label[mode]!=undefined)
					isgo=false;
			}else
				isgo=true;
			if(!isgo)
				resolve({state:1});
			else{
				var paraminfo={
					sys:'平台',
					mode:mode,
					lang:lang
				}
				var that=this;
				_this.$apipost.get.GetLanguageByMode({paraminfo:paraminfo}).then(res => {
					//debugger
					if(res.label[mode]==undefined)
						res.label[mode]={};
					if(res.label[mode]!=undefined){
						if(_this.$lang.label==undefined){
							_this.$lang.label={};
							_this.$lang.label[mode]=res.label[mode];
						}
						else
						{
							if(_this.$lang.label[mode]==undefined)
								_this.$lang.label[mode]=res.label[mode];
							else{
								var langlabel=that.twoJsonMerge(_this.$lang.label[mode],res.label[mode]);
								_this.$lang.label[mode]=langlabel;
							}
						}
					}
					_this.$langtype=res.lang;
					resolve({state:1});	
				}).catch(e=>{
					resolve({state:0});
				});
			}
		});
	},
	//两个json实体类合并
	twoJsonMerge(json1,json2){
		var length1 = 0,length2 = 0,jsonStr,str;
		for(var ever in json1) length1++;
		for(var ever in json2) length2++;
		if(length1 && length2)str = ',';
		else str = '';
		jsonStr = ((JSON.stringify(json1)).replace(/,}/,'}') + (JSON.stringify(json2)).replace(/,}/,'}')).replace(/}{/,str);
		return JSON.parse(jsonStr);
	},
	BtnClick(param){
		var isgo=true;
		if(param.colattr!=undefined){
			var newparam={};
			newparam=param.colattr;
			newparam.row=param.row;
			if(newparam.isedit==undefined||newparam.isedit=='')
				newparam.isedit=1;
			if(newparam.iscopy==undefined||newparam.iscopy=='')
				newparam.iscopy=1;	
			if(newparam.isdetail!=undefined)
				newparam.isdetail=newparam.isdetail;	
			param=newparam;
		}
		debugger
		if(param.l_handetype.indexOf('opentab')>-1){
			param.l_url='opentab';
			if(param.l_tabname!=''&&param.l_tabname!=undefined)
				param.l_name=param.l_tabname;
			else if(param.title!=undefined&&param.title!='')
				param.l_name=param.title;
				
			if(param.l_handetype=='opentab-edit')
				param.urlparam={pkval:param.row.pkval,isedit:param.isedit};
			else if(param.l_handetype=='opentab-copy')
				param.urlparam={pkval:param.row.pkval,iscopy:param.iscopy};	
			else if (param.l_handetype=='opentab-read'){
				param.urlparam={pkval:param.row.pkval};
			}
			if(param.isdetail!=undefined)
				param.urlparam={pkval:param.row.pkval,isdetail:param.isdetail};
		}
		if(param.l_handetype.indexOf('openwin')>-1){
			param.l_url='openwin';
			if(param.l_tabname!=''&&param.l_tabname!=undefined)
				param.l_name=param.l_tabname;
			else if(param.title!=undefined&&param.title!='')
				param.l_name=param.title;
			if(param.l_handetype=='openwin-edit')
				param.urlparam={pkval:param.row.pkval,isedit:param.isedit};
			else if(param.l_handetype=='openwin-copy')
				param.urlparam={pkval:param.row.pkval,iscopy:param.iscopy};	
			else if (param.l_handetype=='openwin-read'){
				param.urlparam={pkval:param.row.pkval};
			}
			if(param.isdetail!=undefined)
				param.urlparam={pkval:param.row.pkval,isdetail:param.isdetail};
		}
		return param;
	},
	encrypt(data) {
	  if (typeof data === "object") {
	    try {
	      // eslint-disable-next-line no-param-reassign
	      data = JSON.stringify(data);
	    } catch (error) {
	      //console.log("encrypt error:", error);
	    }
	  }
	  const dataHex = CryptoJS.enc.Utf8.parse(data);
	  const encrypted = CryptoJS.AES.encrypt(dataHex, SECRET_KEY, {
	    iv: SECRET_IV,
	    mode: CryptoJS.mode.CBC,
	    padding: CryptoJS.pad.Pkcs7
	  });
	  return encrypted.ciphertext.toString();
	},
	decrypt(data) {
	  const encryptedHexStr = CryptoJS.enc.Hex.parse(data);
	  const str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
	  const decrypt = CryptoJS.AES.decrypt(str, SECRET_KEY, {
	    iv: SECRET_IV,
	    mode: CryptoJS.mode.CBC,
	    padding: CryptoJS.pad.Pkcs7
	  });
	  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
	  return decryptedStr.toString();
	},
	BtnEvent(l_id,_this,currentpage,param){
		//debugger
		var isgo=true;
		if(param.l_handetype=='opennewpage')
		{
			//debugger
			var local=window.location.origin;
			window.open(local+param.l_url,'_blank');
			isgo=false;
		}
		if(l_id=='45'){
			//删除入库记录
			this.DelStorageIn(_this);
			isgo=false;
		}
		if(param.l_handetype=='exportbymode'){//导出
			this.ExportByMode(_this,currentpage,param);
			isgo=false;
		}
		if(param.l_handetype=='submitqg'){//申报
			this.Submitqg(_this,currentpage,param);
			isgo=false;
		}
		if(param.l_handetype=='delorder'){//删除订单
			this.Delorder(_this,currentpage,param);
			isgo=false;
		}
		//debugger
		if(param.l_handetype=='getqgresult'){//获取最新清关回执
			this.Getqgresult(_this,param);
			isgo=false;
		}
		if(param.l_handetype=='delschemelist'){//删除报价方案
			this.Delbaojia(_this,currentpage,param);
			isgo=false;
		}
		if(param.l_handetype=='delqgaccount'){//删除申报企业名称
			this.Delqgaccount(_this,currentpage,param);
			isgo=false;
		}
		if(param.l_handetype=='importwin'){//万能导入
			//debugger
			currentpage.$refs.importwinnew.init({
				type:param.l_tablename,
				dialogtitle:param.l_tabname,
				isreload:true
			});
			isgo=false;
		}
		// if(param.l_handetype=='delxj'){//删除询价列表
		// 	this.Delxj(_this,currentpage,param);
		// 	isgo=false;
		// }
		if(param.l_handetype=='delbj'){//删除报价列表
			//debugger
			this.Delbj(_this,currentpage,param);
			isgo=false;
		}
		if(param.l_handetype=='deldd'){//删除货代订单列表
			this.Deldd(_this,currentpage,param);
			isgo=false;
		}
		if(param.l_handetype=='delwf'){//删除应付账单列表
			this.Delwf(_this,currentpage,param);
			isgo=false;
		}
		if(param.l_handetype=='delws'){//删除应收账单列表
			this.Delws(_this,currentpage,param);
			isgo=false;
		}
		if(param.l_handetype=='deltabledata'){//通用删除方法，可删除无复杂业务逻辑的表数据
			this.DelTabledata(_this,currentpage,param,l_id);
			isgo=false;
		}
		if(param.l_handetype=='updatecargopricelabel'){//上传商品价签数据
			this.UploadCargoPriceLabel(_this,param);
			isgo=false;
		}
		
		// if(param.l_handetype=='main_errorwin'){//万能报错(需要扫码才1A可以关闭)
		// 	//debugger
		// 	currentpage.$refs.main_errorwin.init({
		// 		errormsg:param.errormsg,
		// 		isread:param.isread,
		// 		isgo:param.isgo,
		// 		focuscontrol:param.focuscontrol
		// 	});
		// 	isgo=false;
		// }
		// if(param.l_handetype=='main_errorwinbtn'){//万能报错,点击确定按钮才可以关闭的
		// 	//debugger
		// 	currentpage.$refs.main_errorwinbtn.init({
		// 		errormsg:param.errormsg,
		// 		isread:param.isread,
		// 		focuscontrol:param.focuscontrol
		// 	});
		// 	isgo=false;
		// }
		if(param.l_handetype=='importwinfile'){//上传商城商品图片
			//debugger
			currentpage.$refs.importfilenew.init({
				cargotype:param.l_tablename,//为空时电脑端，mobile 是移动端
				dialogtitle:param.l_tabname,
				isreload:true
			});
			isgo=false;
		}
		if(param.l_handetype=='shelveson'){//商品上架
			this.setcargoisshelves(_this,param,1);//设置商品上架/下架
			isgo=false;
		}
		if(param.l_handetype=='shelvesoff'){//商品下架
			this.setcargoisshelves(_this,param,0);//设置商品上架/下架
			isgo=false;
		}
		if(param.l_handetype=='synccargoimg'){//同步商品图片
			this.SyncCargoimg(_this,'');
			isgo=false;
		}
		if(param.l_handetype=='exportbysearch'){//按筛选条件导出
			this.ExportByMode_Search(_this,currentpage,param,l_id);
			isgo=false;
		}
		if(param.l_handetype=='threadresolve_addr'){
			debugger
			this.ThreadResolve_addr(_this,param);
			isgo=false;
		}
		if(param.l_handetype=='printmd'){//打印面单
			debugger
			this.printmd(_this,currentpage,param);
			isgo=false;
		}
		if(param.l_handetype=='downdcargopic')//打开下载商品图片界面
		{
			debugger
			var searchinfo='',col='pkval';
			searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
			if(searchinfo!=""){
				currentpage.$refs.downpic.init({
					searchinfo:searchinfo,
					item:{l_mode:param.l_tablename,type:param.l_tabname}
				});
			}
			isgo=false;
		}
		return isgo;
	},	
	//删除入库记录方法1/2
	DelStorageIn(that) {
		var _this=this;
		//debugger
		var searchinfo =that.GetCheckedOrder(false,'p_pkval');
		if (searchinfo != '') {
			that.$confirm('确定删除所选记录吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
					that.$tool.loading('正在获取勾选数据', 'inlist');
					that.$apipost.post.InsertTemp({ l_mode: that.item.l_mode, tab: that.item.type, search: searchinfo, sort: that.sort }).then(res => {
						that.$tool.loadingclose();
						if (res != '') {
							if (res.batch != '') {
								that.$tool.loading('正在删除', 'inlist');
								_this.DelStorageIn2(res.batch,that);
							} else {
								that.$tool.message('获取数据失败', 0);
							}
						} else {
							that.$tool.message('获取数据失败', 0);
						}
					});
				})
				.catch(() => {});
		}
	},
	//删除入库记录方法2/2
	DelStorageIn2(batch,_this) {
		//var that = this;
		_this.$apipost.post.DelStorageOrder({isin:1,pkval:'',batch: batch}).then(res => {
			_this.$tool.loadingclose();
			if (res.state == '1') {
				_this.$tool.message('操作成功', 1);
				_this.refreshgrid(true);
			} else {
				_this.$tool.message('删除失败', 0);
			}
		});
	},
	//按渠道模板导出
	ExportByMode(_this,currentpage,param){
		//debugger
		var searchinfo =_this.GetCheckedOrder(false,'pkval');
		if (searchinfo != '') {
			//debugger
			var handtype=0;
			if(param.l_tablename!=''&&param.l_tablename!=undefined)
				handtype=param.l_tablename;
				
			_this.$tool.loading(_this.$lang.label.public.checkdata);
			_this.$apipost.post.InsertTemp({ l_mode: _this.item.l_mode, tab: _this.item.type, search: searchinfo, sort: _this.sort }).then(res => {
				_this.$tool.loadingclose();
				if (res != '') {
					if (res.batch != '') {
						currentpage.$refs.exportwinnew.init({
							searchinfo: searchinfo,
							batch: res.batch,
							handtype:handtype
						});
					} else {
						_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
					}
				} else {
					_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
				}
			});
		}
	},
	//按渠道模板导出
	ExportByMode_Search(_this,currentpage,param,l_id){
		//debugger
		var handtype=0;
		if(param.l_tablename!=''&&param.l_tablename!=undefined)
			handtype=param.l_tablename;
		var searchinfo =_this.GetCheckedOrder(true,'pkval');
		if (searchinfo != '') {
			_this.$tool.loading(_this.$lang.label.public.checkdata);
			_this.$apipost.post.InsertTemp({ l_mode: _this.item.l_mode, tab: _this.item.type, search: searchinfo, sort: _this.sort }).then(res => {
				_this.$tool.loadingclose();
				if (res != '') {
					if (res.batch != '') {
						currentpage.$refs.exportwinnew.init({
							searchinfo: searchinfo,
							batch: res.batch,
							handtype:handtype
						});
					} else {
						_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
					}
				} else {
					_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
				}
			});
		}
		else{
			currentpage.$refs.exportbysearch.init({
				handtype:handtype,
				l_id:l_id
			});
		}
	},
	//提交报文到海关
	Submitqg(_this,currentpage,param){
		//debugger
		var searchinfo='',col='p_pkval';
		if(param.row!=undefined){//表示是在列表操作列点击单行操作
			if(param.row[col]!=undefined){
				var search={};
				search[col]='';
				search[col] = param.row[col]; //这里的筛选条件对象的结构与订单筛选条件结构一致
				searchinfo={pkcol:col};
				searchinfo.checkedrow=search;
				searchinfo = JSON.stringify(searchinfo);
			}
			else
				searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
		}
		else
			searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
			
		if (searchinfo != '') {
			_this.$tool.loading(_this.$lang.label.public.checkdata);
			_this.$apipost.post.InsertTemp({ l_mode: _this.item.l_mode, tab: _this.item.type, search: searchinfo, sort: _this.sort }).then(res => {
				_this.$tool.loadingclose();
				if (res != '') {
					if (res.batch != '') {
						currentpage.$refs.submitqg.init({batch:res.batch});
					} else {
						_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
					}
				} else {
					_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
				}
			});
		}
	},
	//删除订单
	Delorder(_this,currentpage,param){
		var that=this;
		var searchinfo='',col='p_pkval';
		if(param.row!=undefined){//表示是在列表操作列点击单行操作
			if(param.row[col]!=undefined){
				var search={};
				search[col]='';
				search[col] = param.row[col]; //这里的筛选条件对象的结构与订单筛选条件结构一致
				searchinfo={pkcol:col};
				searchinfo.checkedrow=search;
				searchinfo = JSON.stringify(searchinfo);
			}
			else
				searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
		}
		else
			searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
			
		if (searchinfo != '') {
			_this.$confirm(_this.$lang.label.public.canceltips, _this.$lang.label.public.remind, {
				confirmButtonText:_this.$lang.label.public.sure,
				cancelButtonText: _this.$lang.label.public.cancel,
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				_this.$tool.loading(_this.$lang.label.public.checkdata);
				_this.$apipost.post.InsertTemp({ l_mode: _this.item.l_mode, tab: _this.item.type, search: searchinfo, sort: _this.sort }).then(res => {
					if (res != '') {
						if (res.batch != '') {
							that.DelOrder2(res.batch,_this.item.l_mode,_this);
						} else {
							_this.$tool.loadingclose();
							_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
						}
					} else {
						_this.$tool.loadingclose();
						_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
					}
				});
			}).catch(() => {});
		}
	},
	DelOrder2(batch,l_mode,_this) {
		_this.$apipost.post.SetOrderToTrash({ l_mode:l_mode, batch: batch, pkval: '', type: 1 }).then(res => {
			_this.$tool.loadingclose();
			if (res.state == '1') {
				_this.$tool.message(_this.$lang.label.public.inoperationsuccess, 1);
				_this.refreshgrid(true,true);
			} else {
				_this.$tool.message(res.message, 0);
			}
		});
	},
	Getqgresult(_this,param){
		var paraminfo='';
		if(param.row!=undefined){
			paraminfo={
				"申报地":param.row.location,
				"查询单号":param.row.searchpkval,
				"报文类型":param.row.bwtype,
				"推送账号":param.row.sendername
			}
		}
		//debugger
		if(paraminfo!=''){
			_this.$apipost.get.Getqgresult({paraminfo:paraminfo}).then(res => {
				if (res.state == '1') {
					_this.$tool.message(_this.$lang.label.public.getcomplete, 1);
					_this.refreshgrid(true);
				} else {
					_this.$tool.message(_this.$lang.label.public.noresult, 2);
				}
			}).catch(e=>{
				_this.$tool.message(_this.$lang.label.public.handleerr, 0);
			});
		}
	},
	//删除报价方案
	Delbaojia(_this,currentpage,param){
		var that=this;
		var searchinfo='',col='c_id';
		if(param.row!=undefined){//表示是在列表操作列点击单行操作
			if(param.row[col]!=undefined){
				var search={};
				search[col]='';
				search[col] = param.row[col]; //这里的筛选条件对象的结构与订单筛选条件结构一致
				searchinfo={pkcol:col};
				searchinfo.checkedrow=search;
				searchinfo = JSON.stringify(searchinfo);
			}
			else
				searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
		}
		else
			searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
			
		if (searchinfo != '') {
			_this.$confirm(_this.$lang.label.public.canceltips, _this.$lang.label.public.remind, {
				confirmButtonText:_this.$lang.label.public.sure,
				cancelButtonText: _this.$lang.label.public.cancel,
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				_this.$tool.loading(_this.$lang.label.public.checkdata);
				_this.$apipost.post.InsertTemp({ l_mode: _this.item.l_mode, tab: _this.item.type, search: searchinfo, sort: _this.sort }).then(res => {
					if (res != '') {
						if (res.batch != '') {
							that.Delbaojia2(res.batch,_this);
						} else {
							_this.$tool.loadingclose();
							_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
						}
					} else {
						_this.$tool.loadingclose();
						_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
					}
				});
			}).catch(() => {});
		}
	},
	Delbaojia2(batch,_this){
		var paraminfo={
			batch:batch
		}
		_this.$apipost.post.delbaojialist({paraminfo:paraminfo}).then(res => {
			_this.$tool.loadingclose();
			if (res.state == '1') {
				_this.$tool.message(_this.$lang.label.public.inoperationsuccess, 1);
				_this.refreshgrid(true,true);
			} else {
				_this.$tool.message(res.message, 0);
			}
		});
	},
	//删除报关账号
	Delqgaccount(_this,currentpage,param){
		var that=this;
		var searchinfo='',col='id';
		if(param.row!=undefined){//表示是在列表操作列点击单行操作
			if(param.row[col]!=undefined){
				var search={};
				search[col]='';
				search[col] = param.row[col]; //这里的筛选条件对象的结构与订单筛选条件结构一致
				searchinfo={pkcol:col};
				searchinfo.checkedrow=search;
				searchinfo = JSON.stringify(searchinfo);
			}
			else
				searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
		}
		else
			searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
			
		if (searchinfo != '') {
			_this.$confirm(_this.$lang.label.public.canceltips, _this.$lang.label.public.remind, {
				confirmButtonText:_this.$lang.label.public.sure,
				cancelButtonText: _this.$lang.label.public.cancel,
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				_this.$tool.loading(_this.$lang.label.public.checkdata);
				_this.$apipost.post.InsertTemp({ l_mode: _this.item.l_mode, tab: _this.item.type, search: searchinfo, sort: _this.sort }).then(res => {
					if (res != '') {
						if (res.batch != '') {
							that.Delqgaccount2(res.batch,_this);
						} else {
							_this.$tool.loadingclose();
							_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
						}
					} else {
						_this.$tool.loadingclose();
						_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
					}
				});
			}).catch(() => {});
		}
	},
	Delqgaccount2(batch,_this){
		var paraminfo={
			batch:batch
		}
		_this.$apipost.post.delqgaccount({paraminfo:paraminfo}).then(res => {
			_this.$tool.loadingclose();
			if (res.state == '1') {
				_this.$tool.message(_this.$lang.label.public.inoperationsuccess, 1);
				_this.refreshgrid(true,true);
			} else {
				_this.$tool.message(res.message, 0);
			}
		});
	},
	//删除询价记录
	Delxj(_this,currentpage,param){
		var that=this;
		//debugger
		var searchinfo='',col='pkval';
		if(param.row!=undefined){//表示是在列表操作列点击单行操作
			if(param.row[col]!=undefined){
				var search={};
				search[col]='';
				search[col] = param.row[col]; //这里的筛选条件对象的结构与订单筛选条件结构一致
				searchinfo={pkcol:col};
				searchinfo.checkedrow=search;
				searchinfo = JSON.stringify(searchinfo);
			}
			else
				searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
		}
		else
			searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
			
		if (searchinfo != '') {
			_this.$confirm(_this.$lang.label.public.canceltips, _this.$lang.label.public.remind, {
				confirmButtonText:_this.$lang.label.public.sure,
				cancelButtonText: _this.$lang.label.public.cancel,
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				_this.$tool.loading(_this.$lang.label.public.checkdata);
				_this.$apipost.post.InsertTemp({ l_mode: _this.item.l_mode, tab: _this.item.type, search: searchinfo, sort: _this.sort }).then(res => {
					if (res != '') {
						if (res.batch != '') {
							that.Delxj2(res.batch,_this);
						} else {
							_this.$tool.loadingclose();
							_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
						}
					} else {
						_this.$tool.loadingclose();
						_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
					}
				});
			}).catch(() => {});
		}
	},
	Delxj2(batch,_this){
		var paraminfo={
			batch:batch,
			handleraccount:localStorage.getItem('u_account')
		}
		_this.$apipost.post.Delxj({paraminfo:paraminfo}).then(res => {
			_this.$tool.loadingclose();
			if (res.state == '1') {
				_this.$tool.message(_this.$lang.label.public.inoperationsuccess, 1);
				_this.refreshgrid(true,true);
			} else {
				_this.$tool.message(res.message, 0);
			}
		});
	},
	
	//删除报价记录
	Delbj(_this,currentpage,param){
		var that=this;
		var searchinfo='',col='pkval';
		if(param.row!=undefined){//表示是在列表操作列点击单行操作
			if(param.row[col]!=undefined){
				var search={};
				search[col]='';
				search[col] = param.row[col]; //这里的筛选条件对象的结构与订单筛选条件结构一致
				searchinfo={pkcol:col};
				searchinfo.checkedrow=search;
				searchinfo = JSON.stringify(searchinfo);
			}
			else
				searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
		}
		else
			searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
			
		if (searchinfo != '') {
			_this.$confirm(_this.$lang.label.public.canceltips, _this.$lang.label.public.remind, {
				confirmButtonText:_this.$lang.label.public.sure,
				cancelButtonText: _this.$lang.label.public.cancel,
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				_this.$tool.loading(_this.$lang.label.public.checkdata);
				_this.$apipost.post.InsertTemp({ l_mode: _this.item.l_mode, tab: _this.item.type, search: searchinfo, sort: _this.sort }).then(res => {
					if (res != '') {
						if (res.batch != '') {
							that.Delbj2(res.batch,_this);
						} else {
							_this.$tool.loadingclose();
							_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
						}
					} else {
						_this.$tool.loadingclose();
						_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
					}
				});
			}).catch(() => {});
		}
	},
	Delbj2(batch,_this){
		var paraminfo={
			batch:batch,
			handleraccount:localStorage.getItem('u_account')
		}
		_this.$apipost.post.Delbj({paraminfo:paraminfo}).then(res => {
			_this.$tool.loadingclose();
			if (res.state == '1') {
				_this.$tool.message(_this.$lang.label.public.inoperationsuccess, 1);
				_this.refreshgrid(true,true);
			} else {
				if(res.state=='2')
				{
					_this.refreshgrid(true,true);
					_this.$tool.message(res.message, 2);
				}
				else
					_this.$tool.message(res.message, 0);
			}
		});
	},

	//删除货代订单记录
	Deldd(_this,currentpage,param){
		var that=this;
		var searchinfo='',col='pkval';
		if(param.row!=undefined){//表示是在列表操作列点击单行操作
			if(param.row[col]!=undefined){
				var search={};
				search[col]='';
				search[col] = param.row[col]; //这里的筛选条件对象的结构与订单筛选条件结构一致
				searchinfo={pkcol:col};
				searchinfo.checkedrow=search;
				searchinfo = JSON.stringify(searchinfo);
			}
			else
				searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
		}
		else
			searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
			
		if (searchinfo != '') {
			_this.$confirm(_this.$lang.label.public.canceltips, _this.$lang.label.public.remind, {
				confirmButtonText:_this.$lang.label.public.sure,
				cancelButtonText: _this.$lang.label.public.cancel,
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				_this.$tool.loading(_this.$lang.label.public.checkdata);
				_this.$apipost.post.InsertTemp({ l_mode: _this.item.l_mode, tab: _this.item.type, search: searchinfo, sort: _this.sort }).then(res => {
					if (res != '') {
						if (res.batch != '') {
							that.Deldd2(res.batch,_this);
						} else {
							_this.$tool.loadingclose();
							_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
						}
					} else {
						_this.$tool.loadingclose();
						_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
					}
				});
			}).catch(() => {});
		}
	},
	Deldd2(batch,_this){
		var paraminfo={
			batch:batch,
			handleraccount:localStorage.getItem('u_account')
		}
		_this.$apipost.post.Deldd({paraminfo:paraminfo}).then(res => {
			_this.$tool.loadingclose();
			if (res.state == '1') {
				_this.$tool.message(_this.$lang.label.public.inoperationsuccess, 1);
				_this.refreshgrid(true,true);
			} else {
				_this.$tool.message(res.message, 0);
			}
		});
	},
	
	//删除应收账单记录
	Delws(_this,currentpage,param){
		var that=this;
		var searchinfo='',col='billid';
		if(param.row!=undefined){//表示是在列表操作列点击单行操作
			if(param.row[col]!=undefined){
				var search={};
				search[col]='';
				search[col] = param.row[col]; //这里的筛选条件对象的结构与订单筛选条件结构一致
				searchinfo={pkcol:col};
				searchinfo.checkedrow=search;
				searchinfo = JSON.stringify(searchinfo);
			}
			else
				searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
		}
		else
			searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
			
		if (searchinfo != '') {
			_this.$confirm(_this.$lang.label.public.canceltips, _this.$lang.label.public.remind, {
				confirmButtonText:_this.$lang.label.public.sure,
				cancelButtonText: _this.$lang.label.public.cancel,
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				_this.$tool.loading(_this.$lang.label.public.checkdata);
				_this.$apipost.post.InsertTemp({ l_mode: _this.item.l_mode, tab: _this.item.type, search: searchinfo, sort: _this.sort }).then(res => {
					if (res != '') {
						if (res.batch != '') {
							that.Delws2(res.batch,_this);
						} else {
							_this.$tool.loadingclose();
							_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
						}
					} else {
						_this.$tool.loadingclose();
						_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
					}
				});
			}).catch(() => {});
		}
	},
	Delws2(batch,_this){
		var paraminfo={
			batch:batch,
			handleraccount:localStorage.getItem('u_account')
		}
		_this.$apipost.post.Delws({paraminfo:paraminfo}).then(res => {
			_this.$tool.loadingclose();
			if (res.state == '1') {
				_this.$tool.message(_this.$lang.label.public.inoperationsuccess, 1);
				_this.refreshgrid(true,true);
			} else {
				_this.$tool.message(res.message, 0);
			}
		});
	},
	//删除应付账单记录
	Delwf(_this,currentpage,param){
		var that=this;
		var searchinfo='',col='billid';
		if(param.row!=undefined){//表示是在列表操作列点击单行操作
			if(param.row[col]!=undefined){
				var search={};
				search[col]='';
				search[col] = param.row[col]; //这里的筛选条件对象的结构与订单筛选条件结构一致
				searchinfo={pkcol:col};
				searchinfo.checkedrow=search;
				searchinfo = JSON.stringify(searchinfo);
			}
			else
				searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
		}
		else
			searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
			
		if (searchinfo != '') {
			_this.$confirm(_this.$lang.label.public.canceltips, _this.$lang.label.public.remind, {
				confirmButtonText:_this.$lang.label.public.sure,
				cancelButtonText: _this.$lang.label.public.cancel,
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				_this.$tool.loading(_this.$lang.label.public.checkdata);
				_this.$apipost.post.InsertTemp({ l_mode: _this.item.l_mode, tab: _this.item.type, search: searchinfo, sort: _this.sort }).then(res => {
					if (res != '') {
						if (res.batch != '') {
							that.Delwf2(res.batch,_this);
						} else {
							_this.$tool.loadingclose();
							_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
						}
					} else {
						_this.$tool.loadingclose();
						_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
					}
				});
			}).catch(() => {});
		}
	},
	Delwf2(batch,_this){
		var paraminfo={
			batch:batch,
			handleraccount:localStorage.getItem('u_account')
		}
		_this.$apipost.post.Delwf({paraminfo:paraminfo}).then(res => {
			_this.$tool.loadingclose();
			if (res.state == '1') {
				_this.$tool.message(_this.$lang.label.public.inoperationsuccess, 1);
				_this.refreshgrid(true,true);
			} else {
				_this.$tool.message(res.message, 0);
			}
		});
	},
	//通用删除列表数据的方法，不包含复杂业务逻辑，仅仅删除表数据
	DelTabledata(_this,currentpage,param,l_id){
		var that=this;
		var searchinfo='',col='pkval';
		if(param.row!=undefined){//表示是在列表操作列点击单行操作
			if(param.row[col]!=undefined){
				var search={};
				search[col]='';
				search[col] = param.row[col]; //这里的筛选条件对象的结构与订单筛选条件结构一致
				searchinfo={pkcol:col};
				searchinfo.checkedrow=search;
				searchinfo = JSON.stringify(searchinfo);
			}
			else
				searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
		}
		else
			searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
			
		if (searchinfo != '') {
			_this.$confirm(_this.$lang.label.public.canceltips, _this.$lang.label.public.remind, {
				confirmButtonText:_this.$lang.label.public.sure,
				cancelButtonText: _this.$lang.label.public.cancel,
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				debugger
				_this.$tool.loading(_this.$lang.label.public.checkdata);
				_this.$apipost.post.InsertTemp({ l_mode: _this.item.l_mode, tab: _this.item.type, search: searchinfo, sort: _this.sort }).then(res => {
					if (res != '') {
						if (res.batch != '') {
							that.DelTabledata2(res.batch,_this,l_id);
						} else {
							_this.$tool.loadingclose();
							_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
						}
					} else {
						_this.$tool.loadingclose();
						_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
					}
				});
			}).catch(() => {});
		}
	},
	//调用删除方法
	DelTabledata2(batch,_this,l_id){
		var paraminfo={
			batch:batch,
			handleraccount:localStorage.getItem('u_account'),
			domain:API.WebServer,
			l_id:l_id
		}
		_this.$apipost.post.DelTabledata({paraminfo:paraminfo}).then(res => {
			_this.$tool.loadingclose();
			if (res.state == '1') {
				_this.$tool.message(_this.$lang.label.public.inoperationsuccess, 1);
				_this.refreshgrid(true,true);
			} else {
				_this.$tool.message(res.message, 0);
			}
		});
	},
	//上传商品价签数据
	UploadCargoPriceLabel(_this,param){
		var that=this;
		var searchinfo='',col='pkval';
		if(param.row!=undefined){//表示是在列表操作列点击单行操作
			if(param.row[col]!=undefined){
				var search={};
				search[col]='';
				search[col] = param.row[col]; //这里的筛选条件对象的结构与订单筛选条件结构一致
				searchinfo={pkcol:col};
				searchinfo.checkedrow=search;
				searchinfo = JSON.stringify(searchinfo);
			}
			else
				searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
		}
		else
			searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
			
		if (searchinfo != '') {
			_this.$tool.loading(_this.$lang.label.public.checkdata);
			_this.$apipost.post.InsertTemp({ l_mode: _this.item.l_mode, tab: _this.item.type, search: searchinfo, sort: _this.sort }).then(res => {
				if (res != '') {
					if (res.batch != '') {
						that.UploadCargoPriceLabel2(res.batch,_this);
					} else {
						_this.$tool.loadingclose();
						_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
					}
				} else {
					_this.$tool.loadingclose();
					_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
				}
			});
		}
	},
	UploadCargoPriceLabel2(batch,_this){
		var paraminfo={
			batch:batch,
			domain:API.WebServer
		}
		_this.$apipost.post.UploadCargoPriceLabel({paraminfo:paraminfo}).then(res => {
			_this.$tool.loadingclose();
			if (res.state == '1') {
				_this.$tool.message(_this.$lang.label.public.inoperationsuccess, 1);
			} else {
				_this.$tool.message(res.message, 0);
			}
		});
	},
	setcargoisshelves(_this,param,type){
			var that=this;
			var searchinfo='',col='pkval';
			if(param.row!=undefined){//表示是在列表操作列点击单行操作
				if(param.row[col]!=undefined){
					var search={};
					search[col]='';
					search[col] = param.row[col]; //这里的筛选条件对象的结构与订单筛选条件结构一致
					searchinfo={pkcol:col};
					searchinfo.checkedrow=search;
					searchinfo = JSON.stringify(searchinfo);
				}
				else
					searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
			}
			else
				searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
				
			if (searchinfo != '') {
				_this.$tool.loading(_this.$lang.label.public.checkdata);
				_this.$apipost.post.InsertTemp({ l_mode: _this.item.l_mode, tab: _this.item.type, search: searchinfo, sort: _this.sort }).then(res => {
					if (res != '') {
						if (res.batch != '') {
							that.setcargoisshelves2(res.batch,_this,type);
						} else {
							_this.$tool.loadingclose();
							_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
						}
					} else {
						_this.$tool.loadingclose();
						_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
					}
				});
			}
	
	},
	setcargoisshelves2(batch,_this,type){
		var paraminfo={
			batch:batch,
			domain:API.WebServer,
			type:type,
			handleraccount: localStorage.getItem('u_account')
		}
		_this.$apipost.post.setcargoisshelves({paraminfo:paraminfo}).then(res => {
			_this.$tool.loadingclose();
			if (res.state == '1') {
				_this.$tool.message(_this.$lang.label.public.inoperationsuccess, 1);
			} else {
				_this.$tool.message(res.message, 0);
			}
		});
	},
	
	SyncCargoimg(_this,type){
		_this.$tool.loading('');
		_this.$apipost.post.SyncCargoimg({cargotype:type}).then(res => {
			_this.$tool.loadingclose();
			if (res.state == '1') {
				_this.$tool.message(_this.$lang.label.public.inoperationsuccess, 1);
			} else {
				_this.$tool.message(res.message, 0);
			}
		});
	},
	//账单存为模板
	savefeetemp(_this,param){
		//debugger
		var obj=this.getmainpage(_this);
		_this.$nextTick(() => {
			//debugger
			obj.$refs.savefeelisttemp.init(param);
		});
	},
	//导入账单模板
	importfeetemp(_this,param){
		var obj=this.getmainpage(_this);
		_this.$nextTick(() => {
			//debugger
			obj.$refs.getfeelisttemp.init(param);
		});
	},
	//获取渠道
	GetClarance(_this,cb) {
		_this.$tool.loading(_this.$lang.label.public.loading, _this.divclass);
		//先加载渠道
		_this.$apipost.get.GetClarance().then(res => {
			//debugger
			_this.pmodelist = res.list;
			if (_this.pmodelist.length > 0) {
				if (_this.orderinfo.p_mode!=undefined) {
					_this.checkedpmode = _this.orderinfo.p_mode;
					_this.pmodelist.forEach(e => {
						if (e.d_name == _this.checkedpmode) {
							_this.p_mode_remark = e.remark;
							return false;
						}
					});
				} else {
					_this.checkedpmode = _this.pmodelist[0].d_name;
					_this.orderinfo.p_mode = _this.checkedpmode;
					_this.p_mode_remark = _this.pmodelist[0].remark;
				}
				if(cb!=undefined)
					cb();
			} else {
				_this.$tool.loadingclose();
			}
		});
	},
	ThreadResolve_addr(_this,param){
		var that=this;
		var searchinfo='',col='pkval';
		if(param.row!=undefined){//表示是在列表操作列点击单行操作
			if(param.row[col]!=undefined){
				var search={};
				search[col]='';
				search[col] = param.row[col]; //这里的筛选条件对象的结构与订单筛选条件结构一致
				searchinfo={pkcol:col};
				searchinfo.checkedrow=search;
				searchinfo = JSON.stringify(searchinfo);
			}
			else
				searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
		}
		else
			searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
			
			
		if (searchinfo != '') {
			_this.$tool.loading(_this.$lang.label.public.checkdata);
			_this.$apipost.post.InsertTemp({ l_mode: _this.item.l_mode, tab: _this.item.type, 
			search: searchinfo, sort: _this.sort }).then(res => {
				if (res != '') {
					if (res.batch != '') {
						ThreadResolve_addr2(_this,res.batch);
					} else {
						_this.$tool.loadingclose();
						_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
					}
				} else {
					_this.$tool.loadingclose();
					_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
				}
			});
		}
	},
	ThreadResolve_addr2(_this,batch){
		_this.$tool.loadingclose();
		if(_this.$parent.$parent.$parent.$refs.desktop!=undefined)
			_this.$parent.$parent.$parent.$refs.desktop[0].ThreadResolve('',batch);
		else
			_this.$parent.$parent.$parent.$parent.$refs.desktop[0].ThreadResolve('',batch);
	},
	//打印面单
	printmd(_this,currentpage,param){
		debugger
		var that=this;
		var searchinfo='',col='pkval';
		if(param.row!=undefined){//表示是在列表操作列点击单行操作
			if(param.row[col]!=undefined){
				var search={};
				search[col]='';
				search[col] = param.row[col]; //这里的筛选条件对象的结构与订单筛选条件结构一致
				searchinfo={pkcol:col};
				searchinfo.checkedrow=search;
				searchinfo = JSON.stringify(searchinfo);
			}
			else
				searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
		}
		else
			searchinfo =_this.GetCheckedOrder(false,col); //列表勾选，批量操作
		if (searchinfo != '') {
			_this.$tool.loading(_this.$lang.label.public.printing,_this.divclass);
			if (currentpage.$refs.printhandler != undefined) {
				var orderinfo={
					mode:_this.$parent.item.l_mode,
					tab:_this.$parent.item.type,
					searchinfo:searchinfo
				}
				currentpage.$refs.printhandler.init({
					pageparam:_this._data,
					isgrid: true,
					pkval: '',
					searchinfo: searchinfo,
					funcode: '01', //funcode --01从获取用户权限内的打印模板开始的
					handtype: 13, //1--取单号 2--取快递单并打印 3-取快递单并预览
					isrollback: false,
					parentpage: this,
					isprint: 1,
					sys:param.l_tablename,
					orderinfo:orderinfo
				});
			}
		}
	},
	downcargopic(_this,searchinfo){
			var that=this;
			if (searchinfo != '') {
				_this.$tool.loading(_this.$lang.label.public.checkdata);
				_this.$apipost.post.InsertTemp({ l_mode: _this.item.l_mode, tab: _this.item.type, search: searchinfo, sort: _this.sort }).then(res => {
					debugger
					if (res != '') {
						if (res.batch != '') {
							that.downcargopic2(res.batch,_this);
						} else {
							_this.$tool.loadingclose();
							_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
						}
					} else {
						_this.$tool.loadingclose();
						_this.$tool.message(_this.$lang.label.public.getdatafail, 0);
					}
				});
			}
	},
	downcargopic2(batch,_this){
		var paraminfo={
			batch:batch,
			domain:API.WebServer,
			filenamerule:_this.filenamerule,
			token:localStorage.getItem('token')
		}
		_this.$tool.loadingclose();
		_this.$tool.loading(_this.$lang.label.public.downing);
		_this.$apipost.post.DownCargoPic({paraminfo:paraminfo}).then(res => {
			_this.$tool.loadingclose();
			if (res.state == '1') {
				if(res.filedomainurl!=undefined){
					if(res.filedomainurl!=""){
						debugger
						var filename=res.filedomainurl.substring(res.filedomainurl.lastIndexOf('/')+1,res.filedomainurl.length);
						_this.$tool.DownFileByurl(res.filedomainurl,filename);
					}
				}
				if(res.filename!=undefined){
					if(res.filename!="")
						_this.$tool.downfile(_this,res.filename,batch);
				}
				if(_this.isshow!=undefined)
					_this.isshow=false;
				_this.$tool.message(_this.$lang.label.public.inoperationsuccess, 1);
			} else {
				_this.$tool.message(res.message, 0);
			}
		});
	},	
}